// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"b097da4e","379":"9136876a"}[chunkId] + ".chunk.js";
};